module.exports = __webpack_public_path__ + "assets/8211c95d19e588c885af9d465832b6b2.png";